import { useContext } from 'react'

import { OrderDraftMutationStatusContext } from './OrderDraftMutationStatusContext'

export const useOrderDraftMutationStatusContext = () => {
  const context = useContext(OrderDraftMutationStatusContext)

  if (!context) {
    throw new Error(
      'useOrderDraftMutationStatusContext must be used within an OrderDraftMutationStatusContextProvider'
    )
  }

  return context
}
